import {name, version} from '../../package.json'
import router from '@/router'
import store from '@/store'
import {$alert, getTimeRemaining, startRemoteSettingsScheduler} from '@/modules/Utils'
import {neptingLogin} from '@/modules/Banking'

import {Utils} from 'moduleutils'
import {MetierWsTpu} from 'modulewebservice'
import {MetierLocalStorage} from 'modulelocalstorage'
import {
  ActionEnum,
  CategoryEnum,
  ColorEnum,
  CreditEnum,
  DrawerFullOptions,
  EnumModeCashiers,
  IntentAction,
  LyfpayNull
} from './Enums'
import i18n from '../lang/index.js'
import {$getNumberOfTransactions} from '@/modules/Transactions'

export class Initialisation {
  //

  /**
   * Connexion utilisateur
   * Récupération des points de vente associés
   *
   * @param {*} user user
   * @param {*} pass pass
   * @param {*} callbackSuccess callbackSuccess
   * @param {*} callbackError callbackError
   * @param replace
   */
  static connection (user, pass, callbackSuccess, callbackError, replace = false) {
    store.commit('loader', i18n.t('loader.connection'))

    MetierWsTpu.callCashier(user, pass)
      .then(
        (response) => {
          if (response.OK === 1) {
            MetierLocalStorage.setUser({
              user: user,
              pass: pass,
              lockpass: null
            })
            MetierLocalStorage.setIdUser(response.IDUtilisateur)

            let userName = response.Nom + ' ' + response.Prenom
            MetierLocalStorage.setNomUser(userName)
            store.commit('userName', userName)

            if (response.LstDroits.length === 1) {
              this.prepareInitialisation(response.LstDroits[0], callbackError, replace)
            } else {
              store.commit('loader', false)

              MetierLocalStorage.setShops(response.LstDroits)
              store.commit('shops', response.LstDroits)

              callbackSuccess(response.LstDroits)
            }
          } else {
            store.commit('loader', false)
            callbackError(response.Msg)
          }
        },
        (e) => {
          store.commit('loader', false)
          callbackError(e.message)
        }
      )
  }

  /**
   * Préparation initisalitaion device
   *
   * @param {*} shop shop
   * @param {*} callbackError callbackError
   * @param replace
   */
  static prepareInitialisation (shop, callbackError, replace = false) {
    // Définition du rang (connexion utilisateur)
    const rank = (shop.Rang && shop.rang !== '') ? ('000' + shop.Rang).slice(-3) : '993'
    MetierLocalStorage.setRang(rank)

    // Définition du numéro de série
    const deviceSerial = device.serial !== 'unknown' ? device.serial
      : device.uuid !== null ? device.uuid
        : 'myterminal-desktop'
    MetierLocalStorage.setSerial(shop.IDPointDeVente + '@' + deviceSerial)

    // Sauvegarde des droits utlisateurs
    MetierLocalStorage.setUserRights(shop.binDroits)

    this.initWebService(
      shop.IDPointDeVente,
      shop.Licence,
      callbackError,
      replace
    )
  }

  /**
   * Initialisation device
   *
   * @param {*} pdv pdv
   * @param {*} licence licence
   * @param {*} callbackError callbackError
   * @param replace
   */
  static initWebService (pdv, licence, callbackError, replace = false) {
    store.commit('loader', i18n.t('loader.initialisation'))
    const idPdv = parseInt(pdv)
    const serial = MetierLocalStorage.getSerial()
    const rank = MetierLocalStorage.getRang()

    MetierWsTpu.callInit(idPdv, licence, rank, serial, device.model, device.version, replace)
      .then(
        (response) => {
          if (response.OK === 1) {
            MetierLocalStorage.setIdPointDeVente(idPdv)
            MetierLocalStorage.setLicence(licence)
            MetierLocalStorage.setApiKey(response.APIKey)
            MetierLocalStorage.setIdMarchand(response.IDMarchand)

            this.initSession(callbackError)
          } else {
            store.commit('loader', false)
            callbackError(response.Msg)
          }
        },
        (e) => {
          store.commit('loader', false)
          callbackError(e.message)
        }
      )
  }

  /**
   * Initialisation session
   *
   * @param {*} callbackError callbackError
   */
  static initSession (callbackError) {
    store.commit('loader', i18n.t('loader.session'))

    MetierWsTpu.callInitSession(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getApiKey(),
      `${name}@${version}`
    )
      .then(
        (response) => {
          if (response.OK === 1) {
            MetierLocalStorage.setSession(response.Session)

            this.initTeleparametrage(callbackError)
          } else {
            store.commit('loader', false)
            callbackError(response.Msg)
          }
        },
        (e) => {
          store.commit('loader', false)
          callbackError(e.message)
        }
      )
  }

  /**
   * Paramétrage device
   *
   * @param {*} callbackError callbackError
   * @param startedByScheduler
   */
  static initTeleparametrage (callbackError, startedByScheduler = false) {
    store.commit('loader', i18n.t('loader.telepametrage'))
    MetierWsTpu.callTeleparametrage(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      MetierLocalStorage.getSerial()
    )
      .then(
        (response) => {
          if (response.OK === 1) {
            localStorage.removeItem('connectedCashier')
            let teleparameters = Utils.createRemoteSettings(response, false)
            teleparameters.PaiementService = response.PaiementService
            teleparameters.BoostoreService = response.BoostoreService
            teleparameters.InfosPDV = response.InfosPDV
            teleparameters.AvecMarketPlace = response.AvecMarketPlace

            teleparameters.CreationContactMyTerminal = response.CreationContactMyTerminal
            teleparameters.ProgrammesKDO = response.ProgrammesKDO
            // Vérifier si Functions et Cashiers existent avant d'initialiser le mode
            teleparameters.Functions = response.Functions;
            teleparameters.Cashiers = response.Cashiers;
            // Trouver la valeur du mode (SESSION ou FLOATING)
            // Enregistrer la valeur du mode dans le store si elle est valide
            teleparameters.cashierEngagementMode = teleparameters.Functions?.find(func => func.function_parameter_id === 1)?.value ?? EnumModeCashiers.NONE;

            teleparameters.CashierEngagementMode = teleparameters.Functions?.find(func => func.function_parameter_id === 1)?.value ?? EnumModeCashiers.NONE;
            // Créactions droits crédit
            let finalRights = ''
            let pdvRights = response.binDroits
            const userRights = MetierLocalStorage.getUserRights()

            if (userRights !== null && userRights !== '') {
              for (let i = 1; i < pdvRights.length; i = i + 2) {
                if (pdvRights[i] === '1' && userRights[i] === '1') {
                  finalRights += '1'
                } else {
                  finalRights += '0'
                }
              }
            } else {
              if (pdvRights) {
                for (let i = 1; i < pdvRights.length; i = i + 2) {
                  finalRights += pdvRights[i]
                }
              }
            }

            // Enregistrement dans localstorage
            MetierLocalStorage.setNomMarchand(response.EnteteOffline)
            if (response.Adresse) {
              MetierLocalStorage.setAdresseMarchand(
                `${response.Adresse.AdresseA} ${response.Adresse.CodePostal} ${response.Adresse.Ville}`
              )
            }
            store.commit('merchantName', response.EnteteOffline)
            MetierLocalStorage.setRights(finalRights)
            store.commit('creditPermissions', finalRights)

            if (response.SiteWeb) {
              MetierLocalStorage.setSiteWeb(response.SiteWeb)
            }

            // Enregistrement de l'heure d'appel + programmation téléparamétrage auto
            let remoteSettingsInfos = MetierLocalStorage.getRemoteSettingsAuto()
            remoteSettingsInfos.last = Date.now()

            if (teleparameters.HeureAppel !== null && teleparameters.HeureAppel.length === 4) {
              // On repart pour 24H si le téléparamétrage est déclenché par le Job
              // ET que l'heure d'appel n'a pas changée, sinon on calcul le temps restant
              const restartForOneDay = startedByScheduler && remoteSettingsInfos.time === teleparameters.HeureAppel

              remoteSettingsInfos.time = teleparameters.HeureAppel

              MetierLocalStorage.setRemoteSettingsAuto(remoteSettingsInfos)

              // Si le téléparamétrage auto est activé, on lance la programmation
              if (remoteSettingsInfos.used) {
                if (restartForOneDay) {
                  startRemoteSettingsScheduler(1439) // ((24 * 60) - 1)
                } else {
                  startRemoteSettingsScheduler(getTimeRemaining())
                }
              }
            }

            MetierLocalStorage.setRemoteSettingsAuto(remoteSettingsInfos)

            this.checkLyfPay(response, teleparameters, finalRights, callbackError)
          } else {
            store.commit('loader', false)
            callbackError(response.Msg)
          }
        },
        (e) => {
          store.commit('loader', false)
          callbackError(e.message)
        }
      )
  }

  static checkLyfPay (response, teleparameters, finalRights, callbackError) {
    // Initialisation LYFPAY
    if (response.LyfPay && IS_ANDROID) {
      MyPay.init(
        { token: response.LyfPay.Token },
        () => {
          this.formatRemoteSettings(response, teleparameters, finalRights, callbackError)
        },
        (e) => {
          teleparameters.LyfPay = LyfpayNull
          this.formatRemoteSettings(response, teleparameters, finalRights, callbackError)
        }
      )
    } else {
      teleparameters.LyfPay = LyfpayNull
      this.formatRemoteSettings(response, teleparameters, finalRights, callbackError)
    }
  }

  static formatRemoteSettings (response, teleparameters, finalRights, callbackError) {
    // Scénarios
    teleparameters.isMobil = false
    teleparameters.postJackpot = false
    teleparameters.checkTransaction = false
    if (response.Scenarios && response.Scenarios.length > 0) {
      response.Scenarios.forEach(scenario => {
        // Contrôle is Mobil
        if (scenario.id === 2 && scenario.nom.toLowerCase() === 'mobil') {
          teleparameters.isMobil = true
          teleparameters.questionsMobil = scenario.questions
        }
        // Contrôle is Béssé
        if (scenario.id === 3 && scenario.nom.toLowerCase() === 'postcagnottage') {
          teleparameters.postJackpot = true
        }
        // Contrôle is Collectionneurs
        if (scenario.id === 4 && scenario.nom.toLowerCase() === 'checktransaction') {
          teleparameters.checkTransaction = true
        }
      })
    }

    // Partenaires de paiement
    teleparameters.useVivaWallet = false
    teleparameters.useRestoFlash = false
    teleparameters.useBanking = true
    teleparameters.PartPay.forEach((partner) => {
      if (partner.toLowerCase() === 'vivawallet') {
        teleparameters.useVivaWallet = true
      }
      if (partner.toLowerCase() === 'restoflash') {
        teleparameters.useRestoFlash = true
      }
      if (partner.toLowerCase() === 'nobancaire') {
        teleparameters.useBanking = false
      }
    })

    // Définition options de la touche 'raccourci'
    let actions = this.formatActions(teleparameters, finalRights)
    let menu = this.formatShorcutActions(teleparameters)

    // Contrôle affichage clavier raccourci
    teleparameters.isGiftOnly = teleparameters.useGift && !teleparameters.VCH && actions.length === 0
    teleparameters.useGiftReset = (response.KDO !== undefined && response.KDO.CARTE !== undefined && response.KDO.CARTE.ResetAutorise === 1)
    teleparameters.useInvoicePayment = (response.PaiementFacture !== undefined && response.PaiementFacture === true)
    teleparameters.useOnlineRefill = response.RefillOnline === 1

    // Drawer options
    this.setDrawerOptions(teleparameters.isMobil, response.IDCatalogue === 'EAS')

    // Mise en mémoire des paramètres
    MetierLocalStorage.setTeleparametres(teleparameters)
    store.commit('teleparameters', teleparameters)
    MetierLocalStorage.setActions(actions)
    store.commit('actionItems', actions)
    MetierLocalStorage.setMenuItems(menu)
    store.commit('menuItems', menu)

    // Définition du raccourci par défaut
    MetierLocalStorage.setFavoriteItem(menu.length - 1)
    store.commit('favoriteItem', menu.length - 1)

    // Récupération liste produits (si pas Mobil et si IDCatalogue)
    if (!teleparameters.isMobil && response.GestionCatalogue === 1 && response.IDCatalogue !== 0) {
      // Enregistrement de l'id du catalogue -> Récupération des produits
      MetierLocalStorage.setIdCatalogue(response.IDCatalogue)
      this.initProducts(response.IDCatalogue, callbackError,
        () => {
          this.checkOffline(response, teleparameters, callbackError)
        }
      )
    } else {
      MetierLocalStorage.setIdCatalogue(null)
      MetierLocalStorage.setProducts([])
      MetierLocalStorage.setConsignes([])
      store.commit('listproducts', [])
      store.commit('consignes', [])
      this.checkOffline(response, teleparameters, callbackError)
    }
  }

  static checkOffline (response, teleparameters, callbackError) {
    // Si on est sur Android, on initialise le plugin cashless
    if (IS_ANDROID) {
      // Vérification PME OFFLINE
      if (response.PME && response.PME.Offline === 1) {
        if (response.PMEOffline.Nb === 1) {
          // Si un seul programme, on initialise le plugin en mode offline
          this.initCashlessPlugin(response.PMEOffline.Programs[0], callbackError)
        } else {
          // Envoi vers choix du programme
          store.commit('loader', false)
          router.replace({ name: 'offline-choice', params: { programs: response.PMEOffline.Programs, ticket: response.Ticket } })
        }
      } else if (teleparameters.LyfPay.Token !== null) {
        // Initialisation du plugin en mode online
        this.initCashlessPlugin(null, callbackError, false)
      } else {
        this.toHome()
      }
    } else {
      if (response.PME && response.PME.Offline === 1) {
        MetierLocalStorage.partialClear()
        store.dispatch('partialClear')

        store.commit('loader', false)
        callbackError(i18n.t('error.offline_not_android'))
      } else {
        this.toHome()
      }
    }
  }

  static toHome () {
    if (IS_ANDROID) {
      // Contrôle de l'heure du terminal Android (à 5 minutes près)
      MetierWsTpu.callTime()
        .then((response) => {
          const serverDate = response.TimestampUTC
          const start = Date.now() - (5 * 60000)
          const end = Date.now() + (5 * 60000)

          if (serverDate < start || serverDate > end) {
            $alert('Votre terminal n\'est pas à l\'heure !', 'warning', '', -1, [{
              title: i18n.t('button.open_settings'),
              color: 'info',
              click: () => { CissAndroid.openSettings('date') }
            }])
          }
        })

      // Start transactions service
      $getNumberOfTransactions()

      // Save payment service for API
      CissAndroid.setPaymentService(store.getters.paymentService)

      // NEPTING SERVICE
      if (
        IS_ANDROID &&
        store.getters.paymentService === 'nepting' &&
        store.getters.paymentParams.merchantId
      ) {
        neptingLogin(
          store.getters.paymentParams.merchantId,
          store.getters.paymentParams.server
        )
      }

      const logins = this.getLogins()
      CissAndroid.saveLogins(logins)

      // Si on a un intent en mémoire, on retourne OK
      if (store.getters.externalAction === IntentAction.INIT) {
        CissAndroid.sendSuccess({
          ...logins,
          posInfos: store.getters.posInfos,
          params: store.getters.boostoreParams
        })
        return
      }
    }

    store.commit('loader', false)

    if (IS_PAX && store.getters.paymentService === 'pax' && router.currentRoute.path !== '/settings') {
      router.replace({ name: 'settings', params: { toTab: 1 } })
    } else if (router.currentRoute.path !== '/home') {
      router.replace('/home')
    }
  }

  static setDrawerOptions (isMobil = false, isMHR = false) {
    let options = DrawerFullOptions

    if (isMobil) {
      options = {
        infos: 0,
        search: 1,
        duplicate: 1,
        cancel: 1,
        consult: 1,
        collect: 1
      }
    } else if (isMHR) {
      options = {
        infos: 1,
        search: 0,
        duplicate: 1,
        cancel: 0,
        consult: 1,
        collect: 1
      }
    }

    MetierLocalStorage.setDrawerOptions(options)
    store.commit('drawerOptions', options)
  }

  static initCashlessPlugin (program, callbackError, offline = true) {
    store.commit('loader', i18n.t('loader.initialisation_cashless'))
    MetierLocalStorage.setSansContact(true)

    let rank = MetierLocalStorage.getRang()
    if (rank === null || rank === 'null') {
      rank = MetierLocalStorage.getSerial().substring(MetierLocalStorage.getSerial().length - 3)
    }

    let env = MetierLocalStorage.getEnv()
    if (env === null) env = 0

    let data = {}
    if (offline) {
      data = {
        'merchant': MetierLocalStorage.getIdMarchand(),
        'apikey': MetierLocalStorage.getApiKey(),
        'session': MetierLocalStorage.getSession().session,
        'env': env,
        'serial': MetierLocalStorage.getSerial(),
        // Event infos
        'rank': rank,
        'pdv': MetierLocalStorage.getIdPointDeVente(),
        'user': MetierLocalStorage.getIdUser(),
        'id': program.IDProgram,
        'name': program.Name,
        'init_card_bi': program.InitCard === 1,
        'caution': program.Caution ? program.Caution : 0,
        'frais': program.FraisActivation ? program.FraisActivation : 0,
        'date_start': program.Start ? program.Start.substring(0, 8) : '00000000',
        'time_start': program.Start ? program.Start.substring(8) : '0000',
        'date_end': program.End ? program.End.substring(0, 8) : '00000000',
        'time_end': program.End ? program.End.substring(8) : '0000',
        // Keys
        'key': program.DESKey,
        'salt': program.SaltTicket
      }
      // Enregistrement de l'évenement
      let event = {
        'id': data.id,
        'name': data.name,
        'caution': data.caution,
        'frais': data.frais,
        'init_card_bi': program.InitCard === 1
      }

      MetierLocalStorage.setEvent(event)
      store.commit('event', event)
    } else {
      data = {
        'merchant': MetierLocalStorage.getIdMarchand(),
        'apikey': MetierLocalStorage.getApiKey(),
        'session': MetierLocalStorage.getSession().session,
        'env': env,
        'serial': MetierLocalStorage.getSerial(),
        'online': true
      }
    }

    Cashless.initPlugin(
      data,
      () => {
        if (offline) {
          // Set offline mode
          MetierLocalStorage.setOffline(true)
          store.commit('offline', true)
          // Nfc by default for cashless scan
          MetierLocalStorage.setFavoriteScan(0)
          store.commit('favoriteScan', 0)
        }

        this.toHome()
      },
      (e) => {
        MetierLocalStorage.clear()
        store.dispatch('clear')

        store.commit('loader', false)
        callbackError(e)
      }
    )
  }

  static formatProduct (element, backcolor = '', color = '') {
    return {
      id: element.IDArticle,
      label: element.Libelle,
      description: element.Description,
      max: element.MaxConsigne ? element.MaxConsigne : 0,
      price: element.PrixLibre ? null : element.PrixUnitaireTTC,
      freeprice: element.PrixLibre && element.PrixLibre === 1,
      //
      backcolor: backcolor,
      color: color,
      quantity: 0,
      img: element.b64Image
    }
  }

  /**
   * Récupération catalogue magasin
   *
   * @param {*} idCatalogue idCatalogue
   * @param callbackError
   * @param callbackSuccess
   */
  static initProducts (idCatalogue, callbackError, callbackSuccess) {
    store.commit('loader', i18n.t('loader.download_catalogue'))

    MetierWsTpu.callCatalogueListeArticles(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      idCatalogue,
      MetierLocalStorage.getSerial()
    ).then(
      (response) => {
        store.commit('loader', false)

        if (response.OK === 1) {
          let listproducts = []
          let otherproducts = []
          let consignes = []

          let env = MetierLocalStorage.getEnv()
          if (env === null) {
            env = 0
          }

          let idConsigne = env === 0 ? 2319451 : 2126047
          let idDeconsigne = env === 0 ? 2319456 : 2126048

          localStorage.setItem('idConsigne', idConsigne)
          localStorage.setItem('idDeconsigne', idDeconsigne)
          store.commit('idConsigne', idConsigne)
          store.commit('idDeconsigne', idDeconsigne)

          response.ProductList.Products.forEach(element => {
            if (element.IDArticle !== idConsigne && element.IDArticle !== idDeconsigne) {
              let linked = null
              switch (element.TypeArticle) {
                case 1:
                  linked = response.ProductList.Products.find(el => el.IDArticle === element.IDArticleReciproque)

                  if (linked !== null) {
                    // Initialisation des compteurs
                    element.number = 0
                    linked.number = 0

                    consignes.push(
                      {
                        consigne: element,
                        deconsigne: linked
                      }
                    )
                  }
                  break
                case 2:
                  // On ne fait rien car c'est de la deconsigne
                  break
                default:
                  try {
                    if (element.Reference === undefined || element.Reference === null) {
                      throw new Error(i18n.t('error.no_reference').toString())
                    }

                    // IndexCategorie - NomCategorie - CouleurBackground - CouleurText - IndexProduit
                    let pos = element.Reference.split('-')

                    let indexCat = parseInt(pos[0])
                    let name = pos[1]
                    let indexProd = parseInt(pos[4])
                    let backcolor = pos[2] ? pos[2] : ''
                    let color = pos[3] ? pos[3] : ''

                    if (isNaN(indexCat) || name === undefined) {
                      throw new Error(i18n.t('error.reference').toString())
                    }

                    let product = this.formatProduct(element, backcolor, color)

                    if (isNaN(indexProd)) {
                      if (listproducts[indexCat] === undefined) {
                        listproducts[indexCat] = {
                          name: name,
                          products: [product]
                        }
                      } else {
                        listproducts[indexCat].products.push(product)
                      }
                    } else {
                      if (listproducts[indexCat] === undefined) {
                        let tmpProducts = []
                        tmpProducts[indexProd] = product

                        listproducts[indexCat] = {
                          name: name,
                          products: tmpProducts
                        }
                      } else {
                        if (listproducts[indexCat].products[indexProd] === undefined) {
                          listproducts[indexCat].products[indexProd] = product
                        } else {
                          let tmpProduct = listproducts[indexCat].products[indexProd]
                          listproducts[indexCat].products[indexProd] = product
                          listproducts[indexCat].products.push(tmpProduct)
                        }
                      }
                    }
                  } catch (e) {
                    otherproducts.push(this.formatProduct(element))
                  }
                  break
              }
            }
          })

          if (otherproducts.length > 0) {
            listproducts.push({
              name: 'Autre',
              products: otherproducts
            })
          }

          MetierLocalStorage.setProducts(listproducts)
          MetierLocalStorage.setConsignes(consignes)
          store.commit('listproducts', listproducts)
          store.commit('consignes', consignes)

          callbackSuccess()
        } else {
          callbackError(response.Msg)
        }
      },
      (e) => {
        store.commit('loader', false)
        callbackError(e.message)
      }
    )
  }

  /**
   * Création du tableau de boutons d'actions
   *
   * @param {*} settings
   * @param {*} creditPermissions
   */
  static formatActions (settings, creditPermissions) {
    let full = []
    if (
      settings.useBanking && (
        IS_PAX || IS_INGENICO || IS_SUNMI || (
          IS_ANDROID && (
            settings.useVivaWallet ||
            (settings.PaiementService && settings.PaiementService.Params && settings.PaiementService.Params.keyAlias)
          )
        )
      )
    ) {
      full.push({
        img: 'cb',
        color: ColorEnum.banking,
        title: 'button.banking_title',
        category: 'button.action_category',
        catcode: CategoryEnum.banking,
        action: ActionEnum.banking
      })
    }
    if (settings.DPA) {
      full.push({
        img: 'dpa',
        color: ColorEnum.ssp,
        title: 'button.dpa_title',
        category: 'button.action_category',
        catcode: CategoryEnum.banking,
        action: ActionEnum.dpa
      })
    }

    // ***** CASHLESS *****
    let pme = []

    // ***** PME CREDIT *****
    let credit = []
    for (let i = 0; i < CreditEnum.length; i++) {
      if (creditPermissions[i] === '1') {
        let img = ''
        switch (CreditEnum[i].mode) {
          case '1':
            img = 'cb'
            break
          case 'C':
            img = 'cheque'
            break
          case 'E':
            img = 'especes'
            break
          case 'W':
            img = 'ecocup'
            break
          case 'O':
            img = 'offert'
            break
          case 'R':
            img = 'catering'
            break
          case 'Y':
            img = 'lydia'
            break
          default:
            img = 'cashless'
            break
        }

        credit.push({
          img: img,
          color: ColorEnum.cashless,
          title: CreditEnum[i].name,
          category: 'button.cashless.credit_choice_cat',
          display: 'button.cashless.credit_choice_display',
          catcode: CategoryEnum.cashless,
          mode: CreditEnum[i].mode,
          action: ActionEnum.cashlessCredit
        })
      }
    }
    if (credit.length > 0) {
      pme.push({
        img: 'cashless',
        color: ColorEnum.cashless,
        title: 'button.cashless.credit_title',
        category: 'button.cashless.category',
        catcode: CategoryEnum.cashless,
        items: credit
      })
    }
    // ***** PME DEBIT *****
    if (settings.PME.Debit === 1) {
      pme.push({
        img: 'cashless',
        color: ColorEnum.cashless,
        title: 'button.cashless.debit_title',
        category: 'button.cashless.category',
        display: 'button.cashless.debit_display',
        catcode: CategoryEnum.cashless,
        action: ActionEnum.cashlessDebit
      })
    }
    // ***** PME RESET *****
    if (settings.PME.ResetAutorise && settings.PME.ResetAutorise === 1) {
      pme.push({
        img: 'cashless',
        color: ColorEnum.cashless,
        title: 'button.cashless.reinit_title',
        category: 'button.cashless.category',
        display: 'button.cashless.reinit_display',
        catcode: CategoryEnum.cashless,
        action: ActionEnum.cashlessReset
      })
    }

    // ***** PME -END- *****
    if (pme.length > 0) {
      full.push({
        img: 'cashless',
        color: ColorEnum.cashless,
        title: 'button.cashless.title',
        category: 'button.action_category',
        catcode: CategoryEnum.cashless,
        items: pme
      })
    }

    // ***** LYFPAY *****
    let lyfpay = []
    if (settings.LyfPay.Direct === 1) {
      if (settings.LyfPay.Debit === 1) {
        lyfpay.push({
          img: 'lyfpay',
          color: ColorEnum.lyfpay,
          title: 'button.lyfpay.debit_title',
          category: 'button.lyfpay.category',
          display: 'button.lyfpay.debit_display',
          catcode: CategoryEnum.lyfpay,
          action: ActionEnum.lyfpayDebit
        })
      }
      if (settings.LyfPay.Credit === 1) {
        lyfpay.push({
          img: 'lyfpay',
          color: ColorEnum.lyfpay,
          title: 'button.lyfpay.credit_title',
          category: 'button.lyfpay.category',
          display: 'button.lyfpay.credit_display',
          catcode: CategoryEnum.lyfpay,
          action: ActionEnum.lyfpayCredit
        })
      }
    }
    if (lyfpay.length > 0) {
      full.push({
        img: 'lyfpay',
        color: ColorEnum.lyfpay,
        title: 'button.lyfpay.title',
        category: 'button.action_category',
        catcode: CategoryEnum.lyfpay,
        items: lyfpay
      })
    }

    // ***** LOYALTY *****
    if (settings.FID === 1) {
      full.push({
        img: 'loyalty',
        color: ColorEnum.loyalty,
        title: 'button.loyalty.title',
        category: 'button.action_category',
        display: 'button.loyalty.display',
        catcode: CategoryEnum.loyalty,
        action: ActionEnum.loyalty
      })
    }

    while (full.length === 1 && full[0].items) {
      full = full[0].items
    }

    return full
  }

  static formatShorcutActions (settings) {
    let menu = [{
      text: 'button.shortcut_badge',
      icon: 'mdi-account-card-details',
      action: ActionEnum.badgeInformations,
      route: 'action-choice'
    }]

    // ***** KDO *****
    if (settings.KDO.CARTE.Debit === 1 ||
      settings.KDO.CARTE.Credit !== 0 ||
      settings.KDO.CHQ.Debit === 1 ||
      settings.KDO.CHQ.Credit !== 0
    ) {
      // Ajout attribut useGift aux settings
      settings.useGift = true
      // Ajout au menu
      menu.push({
        text: 'button.shortcut_gift',
        icon: 'mdi-credit-card-multiple',
        action: ActionEnum.gift,
        route: 'action-choice'
      })
    }

    // ***** RESTO FLASH *****
    if (settings.useRestoFlash) {
      menu.push({
        text: 'button.shortcut_restoflash',
        icon: 'mdi-card-text-outline',
        action: ActionEnum.restoFlash,
        route: 'resto-flash'
      })
    }

    // ***** RESET *****
    if (
      settings.PME.ResetAutorise &&
      settings.PME.ResetAutorise === 1
    ) {
      menu.push({
        text: 'button.shortcut_reinit',
        icon: 'mdi-credit-card-scan',
        action: ActionEnum.cashlessReset,
        route: 'action-choice'
      })
    }

    return menu
  }

  static getLogins () {
    return {
      env: MetierLocalStorage.getEnv(),
      merchantId: MetierLocalStorage.getIdMarchand(),
      apiKey: MetierLocalStorage.getApiKey(),
      rank: MetierLocalStorage.getRang(),
      session: MetierLocalStorage.getSession().session,
      serial: MetierLocalStorage.getSerial()
    }
  }
}
